import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import capitalize from "../../../../../../capitalize";

const EvacModal2 = ({
    driverName,
    setDriverName,
    driverPhone,
    setDriverPhone,
    plateNo,
    setPlateNo,
    nylon,
    setNylon,
    pet,
    setPet,
    showEvac2,
    handleCloseEvac2,
    selectedCategories,
    setSelectedCategories,
    products,
    groupWeights,
    setGroupWeight,
    shortLabels,
    loading,
    captureEvacuationRequest,
    code
}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleCopyCode = () => {
        if (!code) return;
        navigator.clipboard.writeText(code);
        toast.success("Code copied !", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            pauseOnHover: true,
            progress: undefined,
            theme: "light",
        });
    };

    // one ref that wraps BOTH the input and the dropdown
    const categoryContainerRef = useRef(null);

    const handleCheckboxChange = (category) => {
        setSelectedCategories((prev) =>
            prev.includes(category)
                ? prev.filter((c) => c !== category)
                : [...prev, category]
        );
    };

    const handleInputClick = () => {
        setIsDropdownOpen((prev) => !prev);
    };

    const productList = products || [];
    const nameFor = (label) =>
        productList.find((p) => p.label === label)?.name || label;

    const placeholderText = selectedCategories.length
        ? selectedCategories.map(nameFor).join(", ")
        : "Select products";

    // Reliable outside click handler
    useEffect(() => {
        const onDocMouseDown = (e) => {
            if (
                categoryContainerRef.current &&
                !categoryContainerRef.current.contains(e.target)
            ) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", onDocMouseDown);
        return () => document.removeEventListener("mousedown", onDocMouseDown);
    }, []);

    //   console.log(selectedCategories)
    return (
        <div>
            <Modal
                show={showEvac2}
                onHide={() => {
                    // Close = pause. The local draft is kept so the user can
                    // resume this step from the "Resume" card.
                    handleCloseEvac2();
                }}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <div className="px-2">
                        {/* Row 1 */}
                        <div>
                            <p
                                style={{
                                    fontWeight: "600",
                                    color: "#000",
                                    fontSize: "18px",
                                    marginBottom: "4px",
                                }}
                            >
                                Capture Evacuation Request
                            </p>
                            <p style={{ fontSize: "12px", color: "#898989" }}>
                                Step 2 of 2
                            </p>
                            {code && (
                                <div
                                    className="d-flex align-items-center justify-content-between px-3 py-2 mb-2"
                                    style={{
                                        background: "#f7fbe0",
                                        border: "1px solid #c4da00",
                                        borderRadius: "6px",
                                    }}
                                >
                                    <span style={{ fontSize: "13px", color: "#404040" }}>
                                        Evacuation Code:&nbsp;
                                        <b style={{ fontSize: "16px", letterSpacing: "1px" }}>
                                            {code}
                                        </b>
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-sm"
                                        style={{
                                            fontSize: "12px",
                                            color: "#231F20",
                                            border: "1px solid #c4da00",
                                        }}
                                        onClick={handleCopyCode}
                                    >
                                        Copy
                                    </button>
                                </div>
                            )}
                        </div>
                        <Row>
                            <Col xs={12} md={6} className="text-left">
                                <Form.Label htmlFor="driverName">Driver&apos;s Name</Form.Label>
                                <div className="position-relative">
                                    <Form.Control
                                        type="text"
                                        id="driverName"
                                        className="py-4"
                                        value={driverName}
                                        onChange={(e) => setDriverName(e.target.value)}
                                    />

                                </div>
                            </Col>

                            <Col xs={12} md={6} className="text-left">
                                <Form.Label htmlFor="driverPhone">
                                    Driver&apos;s Phone Number
                                </Form.Label>
                                <div className="position-relative">
                                    <Form.Control
                                        type="text"
                                        id="driverPhone"
                                        className="py-4"
                                        maxLength={11}
                                        value={driverPhone}
                                        onChange={(e) =>
                                            setDriverPhone(e.target.value.replace(/[^0-9]/g, ""))
                                        }
                                    />
                                </div>
                            </Col>
                        </Row>

                        {/* Row 2 */}
                        <div className="py-3">
                            <Row>
                                <Col xs={12} md={6} className="text-left">
                                    <Form.Label htmlFor="plateNo">
                                        Vehicle&apos;s Plate No
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            id="plateNo"
                                            className="py-4"
                                            value={plateNo}
                                            onChange={(e) => setPlateNo(e.target.value)}
                                        />
                                    </div>
                                </Col>

                                <Col xs={12} md={6} className="text-left">
                                    <Form.Label>Products being evacuated</Form.Label>

                                    {/* Container ref wraps input + dropdown */}
                                    <div
                                        ref={categoryContainerRef}
                                        className="category-selectors"
                                    >
                                        <Form.Control
                                            type="text"
                                            className="form-control form-control-lg inputStyle py-4"
                                            placeholder={placeholderText}
                                            readOnly
                                            onClick={handleInputClick}
                                            // stop mousedown so document listener doesn't see it
                                            onMouseDown={(e) => e.stopPropagation()}
                                        />

                                        {isDropdownOpen && (
                                            <div className="dropdown mt-2">
                                                {productList.map((product, index) => (
                                                    <div key={product.label} className="dropdown-item">
                                                        <label className="d-flex">
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-${index}`}
                                                                checked={selectedCategories.includes(product.label)}
                                                                onChange={() => handleCheckboxChange(product.label)}
                                                            />
                                                            <span className="mb-0 pl-2">{product.name}</span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        {/* Row 3 – category-specific fields */}
                        <div className="pb-3">
                            <Row>
                                {selectedCategories.map((label) => {
                                    const short = (shortLabels || []).includes(label);
                                    return (
                                        <Col xs={12} md={6} className="text-left" key={label}>
                                            <Form.Label htmlFor={`weight-${label}`}>
                                                {nameFor(label)} (kg)
                                            </Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="text"
                                                    id={`weight-${label}`}
                                                    className="py-4"
                                                    style={short ? { borderColor: "#B4532A" } : undefined}
                                                    value={groupWeights?.[label] ?? ""}
                                                    onChange={(e) =>
                                                        setGroupWeight(label, e.target.value.replace(/[^0-9.]/g, ""))
                                                    }
                                                />
                                            </div>
                                            {short ? (
                                                <small style={{ color: "#B4532A" }}>
                                                    More than this center has baled
                                                </small>
                                            ) : null}
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>

                        <div style={{ width: "40%" }} className="pt-1 pb-3">
                            <button
                                style={{ fontSize: "13px" }}
                                type="button"
                                className="btn loginBtn btn-sm btn-block"
                                disabled={loading || selectedCategories.length === 0 || (shortLabels || []).length > 0}
                                onClick={() => {
                                    captureEvacuationRequest();
                                }}
                            >
                                {loading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    "Capture"
                                )}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default EvacModal2;
